// Trocar capa (§4.3, H93/H115): o link ganha uma imagem enviada como capa (blob da própria conta, pelo
// mesmo PUT /v1/blobs da nota); "voltar à automática" tira a capa e pede nova análise, que busca a capa da página.
import { ACCEPTED_MIME, type Card } from "../../../../shared/types.ts";
import { failed, store, toast } from "../state.ts";
import { closeMenu, MenuSheet } from "./Extras.tsx";
import { IconCover } from "./icons.tsx";

const IMAGE_MIME = ACCEPTED_MIME.filter((m) => m.startsWith("image/")).join(",");

export function CoverButton({ card: c }: { card: Card }) {
  const id = `cover-${c.id}`;
  const hide = () => closeMenu(id);
  const pick = () => {
    hide();
    const input = document.createElement("input");
    input.type = "file";
    input.accept = IMAGE_MIME;
    input.onchange = () => {
      const f = input.files?.[0];
      if (!f) return;
      store
        .uploadBlob(f)
        .then((blob) => store.setCover(c.id, blob))
        .then(() => toast({ key: `cover-set:${c.id}`, text: "Capa trocada." }), () => {}); // falha de envio: o store já avisou
    };
    input.click();
  };
  // ponytail: a capa automática não fica guardada à parte (não há coluna para ela); a nova análise a busca de novo.
  // Depois do sync: a análise tem de ler o card já sem a capa escolhida.
  const automatic = async () => {
    hide();
    try {
      await store.setCover(c.id, null);
      await store.sync();
      await store.reprocess(c.id);
      toast({ key: `cover-auto:${c.id}`, text: "Capa escolhida tirada. A automática volta com a nova análise." });
    } catch (e) {
      if ((e as Error).cause !== "notified") failed();
    }
  };
  return (
    <MenuSheet
      id={id}
      label="Capa do card"
      class="rd-cover-menu"
      trigger={(p) => (
        <button type="button" class="round" {...p} aria-label="Capa" data-tip="Trocar capa">
          <IconCover />
        </button>
      )}
    >
      <button type="button" class="menu-item" onClick={pick}>
        Escolher uma imagem…
      </button>
      {c.coverBlobId && (
        <button type="button" class="menu-item" onClick={automatic}>
          Voltar à capa automática
        </button>
      )}
    </MenuSheet>
  );
}
